import { gql } from 'apollo-boost';

export const previewEPro = gql`
  query previewEPro($previewEPro: EProPreviewInput!) {
    ePro {
      previewEPro(previewEPro: $previewEPro)
    }
  }
`;

export const byCarrierId = gql`
  query byCarrierId($carrierId: ID!, $orgId: ID!) {
    ePro {
      byCarrierId(carrierId: $carrierId, orgId: $orgId) {
        id
        isDeleted
        name
        suspended
        locationInfos {
          locationId
          forInbound
          forOutbound
        }
        sequenceInfos {
          lastValueUsed
          sequenceEnd
          sequenceStart
          exhausted
          sequenceGuid
        }
      }
    }
  }
`;
